/**
 * User tracking service
 */

export class UserTrackingService {
  // Anonymous user tracking is handle through Tag Manager

  /**
   * Handles identified users (with email)
   */
  static connectIdentifiedUser(email) {
    // Braze tracking
    this.connectBrazeUserId(email);
  }


  /**
   * Connect Braze with user identity
   */
  static connectBrazeUserId(userEmail) {
    if (!userEmail) {
      return;
    }
    try {
      window.braze?.getUser()?.setEmail(userEmail);
    } catch (error) {
      console.error('Braze ID connection failed:', error);
    }
  }
}